import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Chart_Interface } from 'src/app/Interface/Chart_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart?token="+Token).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  GetAlert(Token:String,id:number):Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/GetAlert?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  AddEdit(model: Chart_Interface,Token:String):Observable<Chart_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:model.id,
      title:model.title,
      haghOzviayt:model.haghOzviayt,
      positionGrid:model.positionGrid,
      parent:model.parent,
      token:Token
    }
    return this.http.post(environment.BaseUrl + "Daro/Chart/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as Chart_Interface
        })
    )

  }

  Delete(Id: number,
    Type: number,
    Token:String): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/Delete?token=" + Token +
      "&id="+Id +
      "&Type=" + Type).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  UpOrder(Id: number,Token:String): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/UpOrder?token=" + Token + "&id="+Id).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  DownOrder(Id: number,Token:String): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/DownOrder?token=" + Token + "&id="+Id).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  CutOrder(CutId: number,PastId: number,Up: boolean,Token:String): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/CutOrder?token=" + Token
      + "&CutId=" + CutId
      + "&PastId=" + PastId
      + "&Up="+Up).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  ChildOrder(CutId: number,PastId: number,Token:String): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/ChildOrder?token=" + Token
      + "&CutId=" + CutId
      + "&PastId=" + PastId).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

}
